import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { CommonService } from 'src/app/services/common.service';
import * as moment from 'moment';
import { ApiService } from 'src/app/services/api.service';
import endpoints from 'src/app/helpers/endpoints';
import { finalize, takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'fury-partner-leads-table',
  templateUrl: './partner-leads-table.component.html',
  styleUrls: ['./partner-leads-table.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class PartnerLeadsTableComponent implements OnInit, OnDestroy {

  ngUnsubscribe = new Subject<void>();
  @Input() dataSource:  MatTableDataSource<any> = new MatTableDataSource<any>();
  @Input() leadSearchForm: FormGroup;
  @Input() columns: any[] = [];
  @Input() itemList: any[] = [];
  @Input() partnerId: string = "";
  @Input() pageSize: number = 30;
  @Input() pageIndex: number = 0;
  @Input() leadSourceTabName = "All";
  @Output() search = new EventEmitter<any>();
  isLoading: boolean = false;
  assetsUrl = environment.assetsUrl + 'images/';

  constructor(
    public commonService: CommonService,
    private apiservice: ApiService
  ) { }

  ngOnInit(): void {
  }

  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  downloadCSV() {
    this.isLoading = true;
    this.apiservice
      .getBlob(
        `${endpoints.leadManagement.getIncomingLeads(this.partnerId)}${this.getLeadsQueryParams(true)}`
      )
      .pipe(
        finalize(() => (this.isLoading = false)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(
        (res: Blob) => {
          const formattedDate = moment().format('DD-MM-YYYY-hh-mm-ss-a');
          const link = document.createElement("a");
          link.href = URL.createObjectURL(res);
          link.download = `partner-leads-${formattedDate}.csv`;
          link.click();
          link.remove();

          this.apiservice.alert("CSV file downloaded successfully", ErrorType.Success);
        },
        (error: HttpErrorResponse) => {
          this.apiservice.alert(error.message, ErrorType.Error);
        }
      );
  }
  getLeadsQueryParams(isExportCvs = false) {
    const {source,firstName,lastName,verifiedName, emailAddress, mobileNumber, address, city, state,zip, attempts, resultCode, status, lastAgentName } = this.leadSearchForm.value;
    return `?page=${Number(this.pageIndex) + 1}&size=${this.pageSize}&source=${source}&firstName=${firstName}&lastName=${lastName}&verifiedName=${verifiedName}&emailAddress=${emailAddress}&phoneNumber=${mobileNumber}&address=${address}&city=${city}&state=${state}&zip=${zip}&attempts=${attempts}&resultCode=${resultCode}&status=${status}&lastAgentName=${lastAgentName}${isExportCvs ? "&export=1" : ""}${this.leadSourceTabName !== "All" ? `&leadSource=${this.leadSourceTabName}` : ""}`;
  }
  searchData() {
    this.search.emit(this.leadSearchForm.value);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
